/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-16 10:34:26
 */

import { useEffect, useState } from "react";
import "./index.less";
import { fetchStrategySystemImpression } from "@/api/modules/dashBoard";
import { getClientList, getTeamMemberList } from "@/api/modules/team";
import RuleLives from "@/assets/icons/rule_lives.svg";
import RuleSave from "@/assets/icons/rule_save.svg";
import TeamIcon from "@/assets/icons/team.svg";
import ArrowRight from "@/assets/icons/arrow-right.svg";
import RuleImpression from "@/assets/icons/rule_impression.svg";
import UpgradeIcon from "@/assets/images/dashboard_icon_1.png";
import Client from "@/assets/icons/Client.svg";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import teamImage from "@/assets/images/dashboard/team.png";
import avatarBorder from "@/assets/images/dashboard/头像框.png";
import Avatar from "@/components/user/avatar";
import { Divider } from "antd";

function MemberItem(props) {
	const { username, email } = props;
	return (
		<div className="member_item">
			<div className="member_info">
				<div className="avatar">
					<img className="avatarBorder" src={avatarBorder} alt="" />
					<Avatar username={username} size="40px" fontSize="16px" />
				</div>
				<div className="member_detail">
					<span className="username">{username}</span>
					<span className="email">{email}</span>
				</div>
			</div>
			<Divider style={{ marginTop: "16px", marginBottom: "16px" }} />
		</div>
	);
}

const Home = () => {
	const { t } = useTranslation();

	const { teamList, currentTeam, currentUser } = useSelector((state: any) => state.global);

	const [dashboardData, setDashBoardData] = useState({});
	const [TeamMemberList, setTeamMemberList] = useState([]);
	const Navigate = useNavigate();
	useEffect(() => {
		fetchStrategySystemImpression().then(res => {
			setDashBoardData(res.data);
		});

		getTeamMemberList().then(res => {
			let teamList = res.data.list.filter(item => item.acceptInvitation === "1");

			setTeamMemberList(teamList);
		});
	}, [currentTeam]);

	console.log("currentTeam", currentTeam);
	return (
		<div className="dashboardContainer">
			<div className="card_container">
				<div className="card_content card_content_rules_live">
					<img className="card_title_icon" src={RuleLives} />
					<div className="card_title">{t("dashboard.top.card1.title")}</div>
					<div className="card_des">{dashboardData?.strategyNum}</div>
				</div>
				<div className="card_content card_content_rules_save">
					<img className="card_title_icon" src={RuleSave} />
					<div className="card_title">{t("dashboard.top.card2.title")}</div>
					<div className="card_des">
						{dashboardData?.spend}
						<span>usd</span>
					</div>
				</div>
				<div className="card_content card_content_rules_impression">
					<img className="card_title_icon" src={RuleImpression} />
					<div className="card_title">{t("dashboard.top.card3.title")}</div>
					<div className="card_des">
						{dashboardData?.impression}
						<span>{t("dashboard.top.card3.units")}</span>
					</div>
				</div>
			</div>

			<div className="card_container_bottom">
				<div className="card card_team">
					<div className="top">
						<div className="left">
							<div className="title">{t("dashboard.bottom.card1.top.title")}</div>
							<div className="count">{teamList?.length}</div>
						</div>
						<div className="right">
							<img src={TeamIcon} alt="" />
						</div>
					</div>
					<div className="bottom">
						<img src={teamImage} alt="123" />
					</div>
				</div>
				<div className="card card_member">
					<div className="top">
						<div className="left">
							<div className="title">{t("dashboard.bottom.card2.title")}</div>
							<div className="count">{TeamMemberList?.length}</div>
						</div>
						<div className="right">
							<img src={Client} alt="" />
						</div>
					</div>
					<div className="members">
						{TeamMemberList.slice(0, 3).map((item: any) => {
							return <MemberItem key={item.id} username={item.name} email={item.email} />;
						})}
					</div>
					{currentTeam?.ownerId === currentUser?.id && (
						<div className="bottom">
							<Link to="/team">
								<div className="invite">
									<span>{t("dashboard.bottom.card2.button")}</span>
								</div>
							</Link>
						</div>
					)}
				</div>
				<div className="card card_plan">
					<div className="top">
						<div className="title">{t("dashboard.bottom.card3.title")}</div>
						<div className="subtitle">{t("dashboard.bottom.card3.subtitle")}</div>
					</div>
					<div className="bottom">
						<Link to="/billing/plan">
							<div className="upgrade">
								<img className="rocket" src={UpgradeIcon} alt="" />
								<span>{t("dashboard.bottom.card3.bottom.button")}</span>
								<img className="arrow" src={ArrowRight} alt="" />
							</div>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
